/** Primeira leva da gestão. Permissão continua por código; módulo e grupo só organizam a tela. */
export const OPTION_MODULES = [
  {
    id: 'usuario',
    label: 'Usuário',
    groups: [
      {
        id: 'usuario',
        label: 'Usuário',
        codes: [
          { codigo: 'USUARIO_SETOR', label: 'Setor' },
          { codigo: 'USUARIO_CARGO', label: 'Cargo' },
        ],
      },
    ],
  },
  {
    id: 'inspecao',
    label: 'Inspeção',
    groups: [
      {
        id: 'geral',
        label: 'Geral',
        codes: [
          { codigo: 'TIPO_SERVICO', label: 'Tipo de serviço' },
          { codigo: 'CLIENTE', label: 'Cliente' },
        ],
      },
      {
        id: 'uso-mutuo',
        label: 'Uso mútuo',
        codes: [
          { codigo: 'SUBNSMP_USO_MUTUO_TIPO_SERVICO', label: 'Ocorrência' },
          { codigo: 'SUBNSMP_USO_MUTUO_ACAO', label: 'Atuação' },
          { codigo: 'SUBNSMP_USO_MUTUO_CESSIONARIA', label: 'Cessionária responsável' },
          { codigo: 'USO_MUTUO_TIPO_SUCATA', label: 'Material de sucata' },
        ],
      },
      {
        id: 'mtbt',
        label: 'MT/BT',
        codes: [
          { codigo: 'NSMP_SERVICOS_TIPO_SERVICO', label: 'Tipo de serviço' },
        ],
      },
    ],
  },
  {
    id: 'veiculo',
    label: 'Veículo',
    groups: [
      {
        id: 'veiculo',
        label: 'Veículo',
        codes: [
          { codigo: 'MANUTENCAO_VEICULAR_TIPO', label: 'Tipo de manutenção' },
          { codigo: 'NOTA_COMPRAS_PECAS', label: 'Peça' },
        ],
      },
    ],
  },
];

export const moduleCodes = (mod) => (mod?.groups || []).flatMap((group) => group.codes);

export const OPTION_CODE_ALLOWLIST = OPTION_MODULES.flatMap((mod) => moduleCodes(mod));

const BY_CODE = OPTION_CODE_ALLOWLIST.reduce((acc, item) => {
  acc[item.codigo] = item.label;
  return acc;
}, {});

export const optionCodeLabel = (codigo) => BY_CODE[codigo] || codigo;

/** Módulos visíveis para os códigos informados. Código fora da leva entra em Outros. */
export const optionModulesFor = (codigos) => {
  const allowed = new Set(codigos || []);
  const known = new Set(OPTION_CODE_ALLOWLIST.map((item) => item.codigo));
  const modules = OPTION_MODULES
    .map((mod) => ({
      ...mod,
      groups: (mod.groups || [])
        .map((group) => ({
          ...group,
          codes: group.codes.filter((item) => allowed.has(item.codigo)),
        }))
        .filter((group) => group.codes.length > 0),
    }))
    .filter((mod) => mod.groups.length > 0);

  const extras = [...allowed]
    .filter((codigo) => !known.has(codigo))
    .map((codigo) => ({ codigo, label: optionCodeLabel(codigo) }));

  if (extras.length > 0) {
    modules.push({
      id: 'outros',
      label: 'Outros',
      groups: [{ id: 'outros', label: 'Outros', codes: extras }],
    });
  }

  return modules;
};
